<template>
  <v-layout column>
    <h3>Actions</h3>
    <v-flex pt-2 pb-3>
      <v-col>
        <v-flex xs12>
          <v-btn style="margin-left: 0px;" class="text-none" flat @click="showResetPassword = true">
            <v-icon left dark>security</v-icon>Reset Password
          </v-btn>
        </v-flex>
        <ResetPassword
          :show="showResetPassword"
          :userID="driverApplication.user.id"
          :userName="driverApplication.user.name"
          @hideResetPassword="showResetPassword = false"
        />
        <v-dialog v-model="dialog" max-width="400">
          <v-card>
            <v-card-title
              class="headline"
            >Confirm {{mode == 'accept' ? "Accept" : "Reject" }} Application</v-card-title>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn class="text-none" flat text @click="dialog = false">Close</v-btn>
              <v-btn class="text-none" flat text @click="confirm">Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-flex pt-2>
          <v-btn
            @click="showDialogAccept"
            class="text-none"
            style="width: 100%;"
            color="green"
          >Accept</v-btn>
        </v-flex>
        <v-flex pt-2>
          <v-btn @click="showDialogReject" class="text-none" style="width: 100%;" color="red">Reject</v-btn>
        </v-flex>
        <v-flex pt-2 v-if="driverApplication.rejected == false">
          <v-btn
            :href="'/drivers/create?driverApplicationUserId=' + driverApplication.user.id"
            class="text-none"
            style="width: 100%;"
            color="blue"
          >Complete Register</v-btn>
        </v-flex>
      </v-col>
    </v-flex>
  </v-layout>
</template>

<script>
import ResetPassword from "@/components/customer/ResetPassword.vue";

import { replaceStart } from "@/components/util/PhoneNumbers.js";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_search_box",
  components: {
    ResetPassword
  },
  props: {
    driverApplication: Object,
    picture: String,
    taxi: Object
  },
  data: function() {
    return {
      showResetPassword: false,
      dialog: false,
      mode: "accept"
    };
  },
  methods: {
    formatNumber: function(number) {
      return replaceStart(number);
    },
    showDialogAccept: function() {
      this.mode = "accept";
      this.dialog = true;
    },
    showDialogReject: function() {
      this.mode = "reject";
      this.dialog = true;
    },
    confirm: async function() {
      var self = this;
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/driver_signup/${
            this.driverApplication.user.id
          }/acceptApplication?accept=${this.mode == "accept"}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loading = false;

        self.driverApplication.rejected = !(this.mode == "accept");

        if (response.data.error == "no_error") {
          this.dialog = false;
        } else {
          alert("Error " + response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown Error");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
